/**
 * @desc: - 带左右控制按钮的轮播
 * @param  数组 {[list]}
 * @author: vico
 */
import React from 'react';
import Loader from '../../components/icon/Loader.jsx';
import { DOMAIN } from '../../constants/config'

export default class PThotBanner extends React.Component {

  constructor(props) {
    super(props);
    this.handleClickLeft = this.handleClickLeft.bind(this);
    this.handleClickRight = this.handleClickRight.bind(this);
    // 总长度
    this.initNum = 0;
    // 当前位置
    this.actIdx = 0;
    // css3模板
    this.x = 0;
    this.setStylesTmpl();
    this.state = {
      random: Math.random()
    }
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  // 设置css3
  setStylesTmpl() {
    if(this.props.list!=null){
      this.stylesTmpl = {
        transform: 'translate(' + this.x + 'px, 0px)',
        WebkitTransform: 'translate(' + this.x + 'px, 0px)',
        width: this.props.list.length*206+'px',
        transition:"1s"
      }
    }
  }

  // 向左箭头
  handleClickLeft() {
    // 到头了
    let {className} = this.props
    if (this.actIdx <= 0) {
      return false;
    }
    this.actIdx = this.actIdx - 1;
    //每个li元素宽度+margin
    this.x = this.x + 216;
    this.setStylesTmpl();
    this.setState({ random: Math.random() });
  }

  // 向右箭头
  handleClickRight() {
    // 到头了
    let {className} = this.props
    if (this.actIdx >= (this.initNum - 5)) {//可视5个
      return false;
    }
    this.actIdx = this.actIdx + 1;
    //每个li元素宽度+margin
    this.x = this.x - 216;
    this.setStylesTmpl();
    this.setState({ random: Math.random() });
  }

  render() {
    let { list,className} = this.props;
    className = className + " hotBanner-box" || "hotBanner-box"
    // 获取长度
    if(list!=null){
      this.initNum = list.length;
    }
    let bannerStyle = {
      width:"1080px",
      position:"relative",
      margin:"0 auto"
    }
    return (
      <div className={className} style={bannerStyle}>
        <a className="hot-btn btn-left" onClick={this.handleClickLeft}></a>
        <a className="hot-btn btn-right" onClick={this.handleClickRight}></a>
        <div className="hot-game">
          {
            this.initNum === 0 ?
              <Loader />
              :
              <ul className="pt-hot-list" style={this.stylesTmpl}>
                {
                  list.map((row, index) => {
                    return <li className="xc_list" key={index}>
                      <a href={ this.props.className =="bbinbanner-box"?DOMAIN +"livegame/bbinplay/" + row.id:DOMAIN +"ptgame/play/" + row.id} title={row.name} className="xc_l_img" target="_blank">
                        <i className="pt-hot"></i>
                        <img src={row.picture}/>
                        <p className="tag-text">{row.name}</p>
                      </a>
                      <p className="heightLight"></p>
                    </li>
                  })
                }
              </ul>
          }
        </div>
      </div>
    );
  }
}
